<template>
  <div class="tab">
    <div class="pages">
      <!-- @mouseleave="showMaintab=''" -->

      <div
        class="tab-page"
        @mouseleave="showMaintab=''" 
        v-for="(itme, i) in tablist"
        :key="i"
      >
        <div v-if="itme.name == 'Home'" class="logo-home" @click="ckOneTab($event)">
          <img src="@/assets/logo1.png" alt="" />
        </div>
        <div 
        v-else
        class="tab-text" 
        @mouseenter="showMaintab =itme.path"
        @click="goPage(itme.path),nowtab = tablist[i]"
        :class="{ setpage: $route.path == itme.path }">
        <p style="margin-bottom: 5px;white-space:break-spaces;">{{ itme.name }}</p>
        <div style="width: 100%;background-color: black;height: 2px;" v-if="$route.path== itme.path"></div>
      </div>
        <div v-if="showMaintab == itme.path && itme.min_tab" class="tab-page-list2">
          <div v-for="(data,index) in itme.min_tab" 
          :key="index"
          @click="goPage(data.path),nowtab = tablist[i],showMaintab=''"
          style="margin: 10px 0;"
          >
            <span :class="{ setpage: $route.path == data.path }">{{ data.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="AiWinPop" class="ai-pop-win">
      <iframe src="https://buddy.edgeprop.sg/navagrove"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            style="width: 100%;height: 100%;"
            allowfullscreen frameborder="0"></iframe>
      <button @click="AiWinPop = false" class="ai-pop-close">Close</button>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      AiWinPop:false,
      showMaintab:{},
      nowtab:{},
      tablist: [
        {path: "/",name: "Home"},
        // {path: "/Message",name: "ASK EDGEPROP BUDDY"},
        {path: "/",name: "Project Overview"},
        {path: "/Location",name: "Location",min_tab:[{path:"/Location",name: "LOCATION MAP"},{path:"/Pano",name: "AERIAL VIEW"}]},
        {path: "/Facilities",name: "Facilities"},
        {path: "/Model",name: "3D Model"},
        {path: "/FloorPlans",name: "Schematic Chart"},
        {path: "/Gallery",name: "Gallery"},
        {path: "/Brochure",name: "Brochure \n (CONTENT COMING SOON)"},
        {path: "/Developer",name: "Developers"},
        // {path: "/Media",name: "Social Media",min_tab:[{path:"/Map",name: "Location Map"}]},

      ],
    };
  },
  methods: {
    ckOneTab(e){
      e.stopPropagation()
      this.goPage('/');
      this.nowtab={};
      this.$emit('setVideoType',true)
    },
    goPage(pagePath) {
      if( pagePath == '/Brochure'){
        return;
      }
      this.$router.push(pagePath).catch((err) => {});
    },
    goMessageInfo() {
      var type = "iframe"
      var url = "https://buddy.edgeprop.sg/sora?source=audax"

      // // nwjs创建一个新窗口
      // let newWindow = nw.Window.open(url, {
      //   width: 800,
      //   height: 800,
      //   title: url,
      // });

      // // 当新窗口关闭时触发的事件
      // newWindow.on("closed", () => {
      //   newWindow = null;
      // });

      // window.open(url);

      // this.$router
      //   .push({
      //     path: '/Media',
      //     query: {
      //       mediaType: type,
      //       url:url
      //     },
      //   })
      //   .catch((err) => {});
    },
  },
  mounted() {
    console.log(this.$route);
  },
};
</script>

<style lang="less">
.tab {
  position: absolute;
  width: 100%;
  height: 7%;
  display: flex;
  flex-direction: row;
  z-index: 200;
  bottom: 0;
  left: 0;
  // background-color: #62828c;
  color: black;
  // background: linear-gradient(to bottom, #ffffff00, #928dab);

  .logo-home {
    width: 200px;
    // width: 100%;
    // height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      // margin-top: 10%;
      // margin-left: 10%;
      max-width: 100%;
      max-height: 80%;
    }
  }
  .pages {
    width: 100%;
    display: flex;
    height: 100%;
    flex-direction: row;
    justify-content: space-around;
    .tab-page {
      position: relative;
      height: 100%;
      font-size: .8vw;
      font-weight: 500;
      margin: auto 0;
      padding: 0 20px;
      // border-right: 1px 50% solid #9a9fa1;
      text-transform: uppercase;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      .tab-text:hover,.tab-page-list2 div:hover{
        color: white !important;
      }
      .tab-page-list2{
        color: black !important;
        position: absolute;
        bottom: 100%;
        z-index: 999;
        left: 0;
        border-radius: 10px 10px 0 0;
        // width: 270px;
        // height: 100px;
        background-color: #d9e3d1c0;
        text-align: start;
        padding: 10px;
        white-space: nowrap;
      }
    }

  }
  .setpage {
    // color: #ebad33 !important;
    font-weight: 600;
  }
  .ai-pop-win{
    position: fixed;
    width: 500px;
    height: 60%;
    top: 20%;
    left: 50px;
    z-index: 1200;
    background-color: black;
  }
  .ai-pop-close{
    background-color: black;
    color: white;
    border: 0;
    padding: 10px;
    border-radius: 20px;
  }
}

@media screen and (max-height:800px) {
  .tab .pages .tab-page{
    font-size: 14px;
  }
}
@media screen and (max-height:500px) {
  .tab .pages .tab-page{
    font-size: .5rem;
  }
  .ai-pop-win{
    width: 500px;
    height: 80% !important;
    top: 2% !important;
    left: 50px;
    z-index: 1200;
    background-color: black;
  }
  .ai-pop-close{
    padding: 5px !important;
  }
}
</style>






